export const eRecruitmentSearchTitle = 'Tìm kiếm hồ sơ';
export const PENDING_PROCESS_TAB = 'PENDING_PROCESS_TAB';
export const PROCESSED_TAB = 'PROCESSED_TAB';
export const COURSE_SEARCH_TAB = 'COURSE_SEARCH_TAB';

export const tabs = [
  {
    id: PENDING_PROCESS_TAB,
    name: 'Chờ xử lý',
  },
  {
    id: PROCESSED_TAB,
    name: 'Đã xử lý',
  },
];

export const tabsAD = [
  {
    id: PENDING_PROCESS_TAB,
    name: 'Chờ xử lý',
  },
  {
    id: PROCESSED_TAB,
    name: 'Đã xử lý',
  },
  {
    id: COURSE_SEARCH_TAB,
    name: 'Chuyển khóa',
  },
];

export const statusItems = [
  {
    status: 'Chờ Ứng viên hoàn tất',
    type: 'secondary',
  },
  {
    status: 'Ứng viên trả về',
    type: 'secondary',
  },
  {
    status: 'Chờ Quản lý phê duyệt',
    type: 'primary',
  },
  {
    status: 'Đã tạo',
    type: 'turquoise',
  },
  {
    status: 'Chờ AD phê duyệt',
    type: 'warning',
  },
  {
    status: 'Chờ AOS phê duyệt',
    type: 'warning',
  },
  {
    status: 'AOS trả về',
    type: 'warning',
  },
  {
    status: 'Từ chối',
    type: 'default',
  },
  {
    status: 'Hủy',
    type: 'error',
  },
  {
    status: 'AOS đã phê duyệt',
    type: 'success',
  },
  {
    status: 'Chờ AR phê duyệt',
    type: 'warning',
  },
  {
    status: 'AR trả về',
    type: 'warning',
  },
];

export const statusTypeConfig = {
  primaryId: 'stepCode',
  primaryName: 'stepName',
};

export const approvedTypeConfig = {
  primaryId: 'agentCode',
  primaryName: 'agentName',
};

export const classTypeConfig = {
  primaryId: 'classId',
  primaryName: 'classCode',
};

export const channelTypeConfig = {
  primaryId: 'channelCode',
  primaryName: 'channelName',
};
export const channelTypeItems = [
  {
    channelCode: 'AGNT_CHNL',
    channelName: 'Agent Channel',
  },
  {
    channelCode: 'FTA_CHNL',
    channelName: 'FTA Channel',
  },
];

export const documentSearchFilterFormConstructor = {
  tableFilter: {
    fullName: {
      label: 'Họ tên ứng viên',
      name: 'fullName',
    },
    appNo: {
      label: 'Số hồ sơ',
      name: 'appNo',
    },
    idNo: {
      label: 'Số CMND/CCCD ứng viên',
      name: 'idNo',
    },
    amCode: {
      label: 'Quản lý phê duyệt',
      name: 'amCode',
      config: approvedTypeConfig,
    },
    adCode: {
      label: 'AD phê duyệt',
      name: 'adCode',
      config: approvedTypeConfig,
    },
    fromDate: {
      label: 'Ngày tạo hồ sơ (từ ngày)',
      name: 'fromDate',
    },
    email: {
      label: 'Email Ứng viên',
      name: 'email',
    },
    phoneNumber: {
      label: 'Số điện thoại ứng viên',
      name: 'phoneNumber',
    },
    status: {
      label: 'Trạng thái hồ sơ',
      name: 'status',
      config: statusTypeConfig,
      unValue: true,
    },
    toDate: {
      label: 'Ngày tạo hồ sơ (đến ngày)',
      name: 'toDate',
    },
    onboardClassId: {
      label: 'Lớp học',
      name: 'onboardClassId',
      config: classTypeConfig,
    },
    dateStartClass: {
      label: 'Ngày bắt đầu lớp học',
      name: 'dateStartClass',
    },
    dateApprovedByAD: {
      label: 'Ngày AD phê duyệt',
      name: 'dateApprovedByAD',
    },
    channelCode: {
      label: 'Kênh phân phối',
      name: 'channelCode',
      config: channelTypeConfig,
      items: channelTypeItems,
    },
    territoryCode: {
      label: 'Miền',
      name: 'territoryCode',
    },
    courseSearch: {
      label: 'Số hồ sơ chuyển khóa',
      name: 'courseSearch',
    },
  },
};

// default value search from date
export const defaultSearchDateAgo = 15;

export const handleSetDefaultTab = (
  isPaging,
  setIsPaging,
  eRecruitmentPendingData,
  eRecruitmentProcessedData,
  setTabId,
) => {
  if (!isPaging) {
    if (
      (!eRecruitmentPendingData.preCandidateResponse?.length &&
        !eRecruitmentProcessedData.preCandidateResponse?.length) ||
      (eRecruitmentPendingData.preCandidateResponse?.length &&
        eRecruitmentProcessedData.preCandidateResponse?.length)
    ) {
      setTabId(PENDING_PROCESS_TAB);
    } else if (
      eRecruitmentPendingData.preCandidateResponse?.length &&
      !eRecruitmentProcessedData.preCandidateResponse?.length
    ) {
      setTabId(PENDING_PROCESS_TAB);
    } else if (
      !eRecruitmentPendingData?.preCandidateResponse?.length &&
      eRecruitmentProcessedData?.preCandidateResponse?.length
    ) {
      setTabId(PROCESSED_TAB);
    } else {
      setIsPaging(false);
    }
  }
};
